<template>
  <div class="zew" :style="getCustomStyle(startGameConfig)">
    <div class="wew">
      <svg
        xmlns:svg="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.0"
        width="150px"
        height="150px"
        viewBox="0 0 128 128"
        xml:space="preserve"
      >
        <g>
          <circle cx="16" cy="64" r="16" fill="#000000" fill-opacity="1" />
          <circle cx="16" cy="64" r="14.344" fill="#000000" fill-opacity="1" transform="rotate(45 64 64)" />
          <circle cx="16" cy="64" r="12.531" fill="#000000" fill-opacity="1" transform="rotate(90 64 64)" />
          <circle cx="16" cy="64" r="10.75" fill="#000000" fill-opacity="1" transform="rotate(135 64 64)" />
          <circle cx="16" cy="64" r="10.063" fill="#000000" fill-opacity="1" transform="rotate(180 64 64)" />
          <circle cx="16" cy="64" r="8.063" fill="#000000" fill-opacity="1" transform="rotate(225 64 64)" />
          <circle cx="16" cy="64" r="6.438" fill="#000000" fill-opacity="1" transform="rotate(270 64 64)" />
          <circle cx="16" cy="64" r="5.375" fill="#000000" fill-opacity="1" transform="rotate(315 64 64)" />
          <animateTransform
            attributeName="transform"
            type="rotate"
            values="0 64 64;315 64 64;270 64 64;225 64 64;180 64 64;135 64 64;90 64 64;45 64 64"
            calcMode="discrete"
            dur="560ms"
            repeatCount="indefinite"
          />
        </g>
      </svg>
    </div>
  </div>
</template>
<script>
import defaultMixins from '../../mixins/defaultMixin';

export default {
  name: 'mp-loader',
  mixins: [defaultMixins],
  components: {},
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    getCustomStyle(item) {
      let customStyle = {};
      if (item && item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
  },
  beforeDestroy() {},
};
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.zew {
  width: 150px;
  height: 150px;
  position: absolute;
  top: 50%;
  left: 50%;
}
.wew {
  width: 150px;
  height: 150px;
  position: absolute;
  bottom: 50%;
  right: 50%;
}
</style>
